// extracted by mini-css-extract-plugin
export default {"cardAccordionHeader":"AccordionToggle_cardAccordionHeader__WLhsQ","accordion":"AccordionToggle_accordion__SEIqn"};